import React from "react";
import { useTranslation } from "react-i18next";
import Tag from "../../general/antd/tag";
import { TripStatus } from "../../../models/order/response";
import { getTripStatusColor, getTripStatusLabel } from "../../../utils/helpers/trip-helpers";

interface ITripBadgeProps {
  tripId?: number | null;
  tripNumber?: string | null;
  tripStatus?: TripStatus | null;
}

const TripBadge: React.FC<ITripBadgeProps> = ({ tripId, tripNumber, tripStatus }) => {
  const { t } = useTranslation();

  // Check if order is in a trip
  if (tripId === null || tripId === undefined) {
    return <Tag title={t("no_trip")} color="default" />;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
      <Tag title={tripNumber ?? "-"} color={getTripStatusColor(tripStatus)} />
      <span style={{ fontSize: "11px", color: "#666" }}>
        {t(getTripStatusLabel(tripStatus))}
      </span>
    </div>
  );
};

export default TripBadge;
